





























import { Component, Mixins } from "vue-property-decorator";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { RichTextObjectStyleReader } from "../styleReaders";
import { DrawableItemEditorMixin } from "../mixins";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, PainterPropertyEditableMixin, EditPainterPropertyEditableMixin } from "./mixins";
import FillStyleEditor from "../../../drawing/FillStyleEditor.vue";
import PrintBehaviorEditor from "./PrintBehaviorEditor.vue";
import QuotationEditor from "./QuotationEditor.vue";

@Component({
  components: {
    fillStyleEditor: FillStyleEditor,
    printBehaviorEditor: PrintBehaviorEditor,
    quotationEditor: QuotationEditor,
  },
})
export default class RichTextBoxPropertyEditor extends Mixins<
  PropertyEditableMixin
  & DrawableItemEditorMixin
  & DrawerPropertyEditableMixin
  & PainterPropertyEditableMixin
  & EditPainterPropertyEditableMixin
>(
  PropertyEditableMixin,
  DrawableItemEditorMixin,
  DrawerPropertyEditableMixin,
  PainterPropertyEditableMixin,
  EditPainterPropertyEditableMixin,
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new RichTextObjectStyleReader(configuration.style.document.editor.objects.richTextBox);
  }
}
